import {default as SearchIcon} from "@material-ui/icons/Search";

const React = require('react');
const trim = require('mn-utils/trim');
const changeProviderProvider = require("mn-utils/changeProviderProvider");
const handleProviderProvider = require("mn-utils/changeProviderProviderSimple");
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const TextField = require("../../../dumb/TextField/E");
const withState = require("../../../../utils/withState");
const {CURRENCY_ITEMS} = require("../../../../constants");
const Select = require("../../../dumb/Select/J");
const {openPopupWindow} = require("../../../../emitters/popup");
import Popup from '../../../dumb/Popup/C';
import Ripple from '../../../dumb/Ripple';
import {apiAdminAccountsList} from '../../../../api/admin/accounts';
import WrapperWithLoading from '../../../dumb/WrapperWithLoading';
import {default as CancelIcon} from "@material-ui/icons/Cancel";
import {
  apiAdminCheckMasterMerchantAvailability,
  apiAdminCreateMasterMerchant
} from "../../../../api/admin/masterMerchant";
import {openPopupInfo} from "../../../../emitters/popup";
const ButtonA = require('../../../dumb/Button/A');


const MMSearch = ({
  className,
  maxLength,
  value = '',
  ...props
}) => {
  return (
    <div className={`rlv ` + (props.disabled ? 'disabled ' : '') + (className || '')}>
      <div className="abs st50% sl14 x0y-50% layoutRow fhaC fvaC">
        <SearchIcon className="sq21*2 c0"/>
      </div>
      <input
        {...props}
        className="f12 ff$3 h45 w pl45 pr70 bs b1 bc0.25 bgF olN cCT (cCT|o100):i r9 dn bc0.1:(h|f)<1:not[.disabled] o50<1.disabled"
        value={!maxLength && value.length > maxLength ? value.slice(0, maxLength) : value}
      />
      <Ripple
        className={
          `layoutRow fhaC fvaC bg04 abs w45 svr r0_9_9_0 dn o50.disabled`
          + (!value ? ' disabled ' : '')
        }
        onClick={() => props.onChange && props.onChange({target: {value: ''}})}
        disabled={!value}
      >
        <CancelIcon className="sq21*2" />
      </Ripple>
    </div>
  );
};

const fetchMerchants = (offset = 0, accum = []) => {
  const limit = 100;
  return apiAdminAccountsList({offset, limit}).then((res = {}) => {
    const list = (res.list || []).filter((el) => (
      !el.blocked && el.lifeflow === 'ready' && el.user_role === 'merchant'
    )).map((el) => ({...el, full_name: trim(el.full_name)}));
    const count = res.count;
    const next = [...accum, ...list];

    return offset + limit >= count ? next : fetchMerchants(offset + limit + 1, next);
  })
}


const openMerchantSelect = (accountId, handleSelect) => {
  openPopupWindow((setPopupState, popup, onMount) => {
    popup.state = {
      ...popup.state,
      loading: true,
      data: [],
      selected: accountId || '',
      error: ''
    }


    onMount(() => {
      fetchMerchants().then((data) => setPopupState({data, loading: false}));
    })

    return (state) => {
      const dataRaw = state.data || [];
      const selected = state.selected || "";
      const search = state.search || "";
      const error = state.error || "";

      const loweredSearch = search ? search.toLowerCase() : '';

      const data = search
        ? dataRaw.filter(({id, login, full_name}) => {
          return (
            (full_name ? full_name.toLowerCase().includes(loweredSearch) : false)
            || (login ? login.toLowerCase().includes(loweredSearch) : false)
            || id.includes(loweredSearch)
          )
        }) : dataRaw;

      const handleSubmit = () => {
        setPopupState({loading: true});
        apiAdminCheckMasterMerchantAvailability({account_id: selected})
          .then((res) => {
            if (!res.partner_data) {
              handleSelect({target: {value: selected}});
              popup.close();
              return;
            }

            setPopupState({error: 'User already has Master Merchant status'});
          })
          .finally(() => setPopupState({loading: false}));
      }

      return (
        <Popup
          caption={(
            <div className="layoutRow fhaS fvaC w">
              <div>Select Merchant</div>
            </div>
          )}
          className="wmax1200-i"
          onCancel={popup.close}
          text="Select"
          disabled={!selected}
          onSave={handleSubmit}
        >
          <WrapperWithLoading
            className="mt20"
            loading={state.loading}
          >
            <>
              {error && (
                <div className="mb20 f16 fw7 cEC4C4C">
                  {error}
                </div>
              )}
              <div>
                <MMSearch
                  value={search}
                  onChange={(e) => setPopupState({search: e.target.value})}
                />
              </div>
              <div className="hmax100vh-315 mt20 ovyAuto ovx">
                <div className="layoutRow fxwWrap mt-10 mh-10 (w1/3|mt10|ph10)>1">
                  {!!data.length
                    ? data.map(({id, login, full_name}, i) => (
                      <div key={i}>
                        <Ripple
                          className={`
                            h pv15 ph10 b1 bs bc0.25 r8 dn break
                            (bc0|bg0.1).selected (bg0.1):h
                            ` + (selected === id ? ' selected' : '')
                          }
                          onClick={() => {
                            setPopupState({selected: id, error: ''})
                          }}
                        >
                          <span className="dB fw7">{full_name || '-'} ({login || '-'})</span>
                          <span className="dB mt6 f10 c0.5">{id}</span>
                        </Ripple>
                      </div>
                    )) : (
                      <div>
                        No data
                      </div>
                    )
                  }
                </div>
              </div>
            </>
          </WrapperWithLoading>
        </Popup>
      )
    }
  })
}



module.exports = withState((setState) => {

  const handleProvider = changeProviderProvider(setState);
  const changeProvider = handleProviderProvider(setState);

  // const handleChangeCounterpartyName = handleProvider('counterpartyName');
  // const handleChangeAssetCode = changeProvider('assetCode');
  const handleChangeAccountId = handleProvider('accountId');
  const handleChangeReferralCode = handleProvider('referralCode');
  const handleChangeFee = handleProvider('fee');
  const handleChangeFiatCode = changeProvider('fiatCode');

  return (state, props) => {

    const {clicked, accountId, referralCode, fee, fiatCode} = state;

    const invalidAccountId = !accountId;
    const invalidFee = !fee;
    const feeIsNan = isNaN(fee);
    const feeIsOutOfLimits = Number(fee) < 0 || Number(fee) > 100;
    const feeError = invalidFee || feeIsNan || feeIsOutOfLimits;
    const invalidFiatCode = !fiatCode;

    const hasErrors = invalidAccountId
      || feeError
      || invalidFiatCode;

    const onSubmit = () => {
      if (hasErrors) {
        setState({clicked: true});
        return;
      }

      setState({loading: true});

      return apiAdminCreateMasterMerchant({
        account_id: accountId,
        referral_code: referralCode,
        fee: fee / 100,
        fiat_code: fiatCode,
      }).then(() => {
        setState({
          accountId: '',
          referralCode: '',
          fee: '',
          fiatCode: ''
        });
        openPopupInfo(['Success', 'User has Master Merchant access now']);
      }).finally(() => (
        setState({clicked: false, loading: false})
      ))
    };

    return (
      <LayoutA>
        <HeaderA>
          <CaptionA>Add Master Merchant</CaptionA>
        </HeaderA>
        <div className="wmax1250 layoutRow fxwWrap mh-25 (w1/2|p25)>1">
          <div className="(crP-i):h (crP)>.MuiInputBase-input">
            <TextField
              className="mt20 wmax472 mr10>1"
              label="Account ID*"
              value={accountId}
              error={clicked && invalidAccountId}
              helperText="Obligatory Field"
              onClick={() => openMerchantSelect(accountId, handleChangeAccountId)}
            />
          </div>
          <div>
            <TextField
              className="mt20 wmax472 mr10>1"
              label="Referral Code"
              value={referralCode}
              onChange={handleChangeReferralCode}
            />
          </div>
          <div>
            <TextField
              className="mt20 wmax472 mr10>1"
              label="Fee (%)*"
              value={fee}
              onChange={handleChangeFee}
              error={clicked && feeError}
              helperText={
                invalidFee
                  ? 'Obligatory Field'
                  : feeIsNan
                    ? 'Must be a number'
                    : feeIsOutOfLimits
                      ? 'Must not higher than 0 and less than 100'
                      : ''
              }
            />
          </div>
          <div>
            <Select
              className="w (fillF)>svg"
              placeholder="Fiat code*"
              error={clicked && invalidFiatCode}
              items={['USD', 'GBP', 'EUR']}
              value={fiatCode}
              onChange={handleChangeFiatCode}
              helperText="Obligatory Field"
            />
          </div>
        </div>
        <ButtonA
          className="wmax150 mt40"
          onClick={onSubmit}
        >
          Create
        </ButtonA>
      </LayoutA>
    )
  }
})
